<template>
  <a-upload
    style="width: 130px;"
    name="avatar"
    list-type="picture-card"
    class="avatar-uploader"
    :show-upload-list="false"
    :customRequest="uploadImg"
    :before-upload="beforeUpload"
    @change="handleChange"
    accept="image/*"
  >
    <img style="width: 100px; height: 100px" v-if="imageUrl || defaultUrl" :src="imageUrl || defaultUrl" alt="avatar" />
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        Upload
      </div>
    </div>
  </a-upload>
</template>
<script>
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
const OSS = require('ali-oss')
import OssApi from '../api/src/oss/api/OssApi'
const ossApi = new OssApi()
export default {
  name: 'TextbookMakerUpload',
  props: {
    path: String,
    defaultUrl: String
  },
  data() {
    return {
      loading: false,
      imageUrl: '',
    };
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true;
        return;
      }
      // if (info.file.status === 'done') {
      //   // Get this url from response in real world.
      //   getBase64(info.file.originFileObj, imageUrl => {
      //     this.imageUrl = imageUrl;
      //     this.loading = false;
      //   });
      // }
    },
    async beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('请选择图片');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小需要小于2MB');
      }
      return isJpgOrPng && isLt2M;
    },
    async uploadImg(info) {
      console.log(info)
      let res = await ossApi.getStsAkTextbookEditor(this.path)
      console.log(res)
      let region = res.endpoint;
      let fKey = region.indexOf('//') + 2;
      let lKey = region.indexOf('.');
      let client = new OSS({
        region: region.substring(fKey,lKey),
        accessKeyId: res.accessKeyId,
        accessKeySecret: res.accessKeySecret,
        stsToken: res.securityToken,
        bucket: res.bucketName,
      })
      const result = await client.put(`${this.path}${info.file.name}`, info.file)
      console.log(result)
      this.$emit('changeImgUrl', result.url)
      return
    },
  },
};
</script>
<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>